import { useEffect, useState } from "react";

import "./assets/style/App.css";
import "./assets/style/Colors.css";
import Layout from "./pages/layout/Layout";
import { Bounce, ToastContainer } from "react-toastify";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticated } from "./redux/slices/loginSlice";
import {
  updateDeviceStatus,
  updateSideMenuStatus,
} from "./redux/slices/dashboardSlice";
import { SIDE_MENU_STATUS } from "./utils/Constant";
import CenterSpinner from "./components/CenterSpinner";
function App() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  dispatch(checkAuthenticated({}));
  const [width, setWidth] = useState<number>(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    const isMobile = width <= 768;
    if (width <= 1000) {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.CLOSE));
    } else {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.OPEN));
    }
    dispatch(updateDeviceStatus({ isMobile }));

  }, [width]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const { isLoading } = useSelector((state: any) => state.grievances);
  return (
    <div className="App">
      <Layout />
      <CenterSpinner showLoader={isLoading} />
      <ToastContainer
        className="toast-style"
        position="top-center"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}

export default App;
